module.exports = __webpack_public_path__ + "static/media/CreateYourOwn.750c1149.png";